import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
    connect() {
        this.sortable = Sortable.create(this.element, {
            onEnd: this.end.bind(this),
            onUpdate: this.update.bind(this),
        });
    }

    update(event) {
        const items = this.element.querySelectorAll(".form-check");
        items.forEach((item, index) => {
            const orderNumber = item.querySelector(".order-number");
            orderNumber.textContent = index + 1;
        });
    }

    end(event) {
        const item = event.item;
        const id = item.dataset.id;
        const input = item.querySelector(".form-check-input");
        input.value = id;


        this.update();
    }
}
